import IGeoCoordinate from "./IGeoCoordinate";

export enum NearestLocationType {
    Location = "Location",
    LeaseComp = "LeaseComp",
    SaleComp = "SaleComp",
}

export default interface INearestLocation {
    rowId: string;
    type: NearestLocationType;
    entityId: number;
    pipedriveCompanyId: number;
    companyName: string;
    companyLocationCount: number;
    address: string;
    siteName: string | null;
    centerPoint: IGeoCoordinate;
    distance: number;
}
